export const messageKeys = {
  all: ['messages'] as const,
  conversation: (conversationId: string) => [...messageKeys.all, conversationId] as const,
  message: (conversationId: string, messageId: string) =>
    [...messageKeys.all, 'single', conversationId, messageId] as const,
  listPinned: (conversationId: string) => [...messageKeys.all, 'pinned', conversationId] as const,
  reactions: (conversationId: string, messageId: string, filter?: string, pageSize?: number) =>
    [...messageKeys.all, 'reactions', conversationId, messageId, filter, pageSize] as const
};
